<!-- Property of OSF Global Services, Inc., (with its brand OSF Commerce). OSF remains the sole owner of all right, title and interest in the software. Do not copy, sell, reverse engineer or otherwise attempt to derive or obtain information about the functioning, manufacture or operation therein. -->
<style scoped>
.selectAnswers {
    justify-content: center;
    display: flex;
    margin: 1.875rem 0 1.25rem 0;
}
.answersWrapper .selectAnswers a#quizButton {
  width: 12.95rem;
  min-height: 2.875rem;
  height: min-content;
  justify-content: center;
  background-color: #fff;
  font-family: Roboto;
  font-size: 1rem;
  font-weight: 500;
  font-style: normal;
  font-stretch: normal;
  line-height: normal;
  letter-spacing: normal;
  text-align: center;
  text-transform: uppercase;
  color: #7e7885;
  display: inline-flex;
  flex-wrap: wrap;
  align-items: center;
  margin: 0.25rem 1.8rem;
  text-decoration: none;
  overflow: hidden;
  border: 0.25rem solid #7e7885;
  word-break: break-word;
}

a:hover {
  text-decoration: underline;
}

.answersWrapper {
  margin: 1.875rem 0 0 0;
  display: flex;
  align-items: center;
  flex-direction: column;
}

.answersWrapper::before {
  content: "";
}

.answersWrapper::after {
  content: "";
}
.template8wrapper h2 {
  font-weight: 1000;
  font-size: 1.5rem;
}

.subtitleLastItem {
  display: inline-block;
  font-size: 0.8rem;
  font-weight: 500;
  text-align: center;
  color: #7e7885;
  margin-left: -16rem;
  width: 12.95rem;
  overflow-wrap: break-word;
}

.subtitleSecondLastItem {
  display: inline-block;
  font-size: 0.8rem;
  font-weight: 500;
  text-align: center;
  color: #7e7885;
  margin-left: 17rem;
  width: 12.95rem;
  overflow-wrap: break-word;
}

@media (max-width: 576px) {
    .answersWrapper {
        margin: 1.875rem 0 0 0;
        display: flex;
        align-items: center;
        flex-direction: column;
    }
    .selectAnswers {
        display: flex;
        justify-content: center;
        font-size: 0.8rem;
        width: 100%;
        min-width: 7rem;
        gap: 1rem;
    }
    .answerItem {
        width: 100%;
    }
    .answersWrapper .selectAnswers a#quizButton {
        width: 100%;
        margin: 0rem 0rem;
    }
    .subtitleLastItem {
        margin-left: 0rem;
    }

    .subtitleSecondLastItem {
        margin-left: 0rem;
    }
}

@media (max-width: 300px) {
  .selectAnswers {
    display: flex;
    justify-content: center;
    font-size: 0.8rem;
    flex-direction: column;
  }
  .answerItem {
    width: 100%;
  }
  .answersWrapper .selectAnswers a#quizButton {
    display: flex;
    justify-content: center;
    font-size: 0.8rem;
    width: 100%;
    min-width: 7rem;
    margin: 0.25rem 0rem;
  }
  .subtitleLastItem {
    margin-left: 0rem;
   }

  .subtitleSecondLastItem {
        margin-left: 0rem;
  }
}

</style>

<template>
    <div class="template8wrapper ">
        <h2>{{ question.title }}</h2>
        <h3>{{ question.subTitle }}</h3>

        <div class="answersWrapper">
            <select
                class="select2"
                v-model="selected"
                v-on:change="selectAnswer"
                ref="select2"
            >
                <option
                    disabled
                    value=""
                >
                    {{ this.quizData.translations.templateq6select }}
                </option>
                <option
                    v-for="answer in this.selectAnswers"
                    :key="answer.id"
                    :value="answer.id"
                    :title="answer.text"
                >
                    {{ answer.title }}
                    {{ answer.subTitle && answer.subTitle.trim() !== '' ? '-' : '' }}
                    {{ answer.subTitle }}
                </option>
            </select>

            <div
                v-if="this.answers.length > 3"
                class="selectAnswers"
            >
                <a
                    id="quizButton"
                    class="quizButton"
                    href=""
                    :title="lastItem.text"
                    v-on:click.prevent="checkAnswer(lastItem.id); submitQuestion();"
                    v-on:mouseenter="mouseOver(lastItem.id)"
                    v-on:mouseleave="mouseOut(lastItem.id, $event)"
                >{{ lastItem.title }}</a>
                <a
                    id="quizButton"
                    class="quizButton"
                    href=""
                    :title="secondLastItem.text"
                    v-on:click.prevent="checkAnswer(secondLastItem.id); submitQuestion()"
                    v-on:mouseenter="mouseOver(secondLastItem.id)"
                    v-on:mouseleave="mouseOut(secondLastItem.id, $event)"
                >{{ secondLastItem.title }}</a>
            </div>
            <p
                v-show="lastItem.hovered"
                class="subtitleLastItem"
            >
                {{ lastItem.subTitle }}
            </p>
            <p
                v-show="secondLastItem.hovered"
                class="subtitleSecondLastItem"
            >
                {{ secondLastItem.subTitle }}
            </p>
        </div>
    </div>
</template>

<script>

import { forIn } from 'lodash';
import select2 from 'select2';
import '../select2Custom/select2CustomStyle.css';
import $ from 'jquery';

export default {
    components: {
        select2
    },
    name: 'Q8Template',
    data() {
        return {
            selected: ''
        };
    },
    watch: {
        $route() {
            this.applySelect2();
        }
    },
    mounted() {
        this.applySelect2();
    },
    computed: {
        question: function () {
            return this.$store.state.questionData;
        },
        answers: function () {
            return this.$store.state.questionData.answers;
        },
        lastItem: function () {
            return this.answers.slice(-1)[0];
        },
        secondLastItem: function () {
            return this.answers.slice(-2)[0];
        },
        selectAnswers: function () {
            if (this.answers.length > 3) {
                return this.answers.slice(0, -2);
            }
            return this.answers;
        },
        quizData: function () {
            return this.$store.state.quizData;
        }
    },
    methods: {
        applySelect2() {
            this.$nextTick(() => {
                $(this.$el).find('select').select2();
                $('select').select2({
                    minimumResultsForSearch: -1
                });
            });
        },
        selectAnswer: function (event, aid) {
            if (aid) {
                this.$store.commit('setAnswer', aid);
                return;
            }
            this.$store.commit('setAnswer', event.target.value);
        },
        mouseOver: function (aid) {
            this.$store.commit('setHover', [{ aid: aid, hover: true }]);
        },
        mouseOut: function (aid) {
            this.$store.commit('setHover', [{ aid: aid, hover: false }]);
        },
        checkAnswer: function (aid) {
            this.$store.commit('setAnswer', aid);
        },
        submitQuestion: function () {
            var answers = [];
            forIn(this.question.answers, function (answer) {
                if (answer.selected === true) {
                    answers.push(answer.id);
                }
            });

            let data = {
                quizid: this.quizData.quizid,
                qid: this.question.id,
                aid: answers
            };
            this.$store.dispatch('submitQuestion', data);
        }
    }
};
</script>
